import { AnchorHTMLAttributes, DetailedHTMLProps, FC, PropsWithChildren, Ref } from 'react'
import Link from 'next/link'
import config from '@/utils/config'

export type SmartLinkProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

const SmartLink: FC<PropsWithChildren<SmartLinkProps>> = ({
  href,
  target = '_blank',
  children,
  ref,
  ...props
}) => {
  const { publicRuntimeConfig } = config
  const l = href?.replace(publicRuntimeConfig.WEB_URL, '') || '#'
  return l.startsWith('http')
    ? (
      <a href={l} target={target} ref={ref} {...props} rel="noreferrer">
        {children}
      </a>
      )
    : (
      <Link href={l} ref={ref as Ref<HTMLAnchorElement>} {...props}>
        {children}
      </Link>
      )
}

export default SmartLink
